const escapeCsvValue = (value) => {
    const str = value == null ? "" : String(value);
    if (/[",\n]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
};

const isExportableColumn = (column) =>
    !column.isDummyField &&
    column.dataField !== "Actions" &&
    column.dataField !== "actions";

const getExportCellValue = (row, column, rowIndex) => {
    if (column.text === "S No.") {
        return rowIndex + 1;
    }

    const raw = row[column.dataField];
    if (column.formatter) {
        const formatted = column.formatter(raw, row, rowIndex);
        if (typeof formatted === "string" || typeof formatted === "number") {
            return formatted;
        }
    }
    if (raw == null || typeof raw === "object") {
        return "";
    }
    return raw;
};

export const exportPayoutTableToCsv = ({columns, data, fileName, dateLabel}) => {
    if (!Array.isArray(data) || !data.length) {
        return;
    }

    const exportColumns = columns.filter(isExportableColumn);
    const headerRow = exportColumns.map((column) => escapeCsvValue(column.text)).join(",");
    const dataRows = data.map((row, rowIndex) =>
        exportColumns
            .map((column) => escapeCsvValue(getExportCellValue(row, column, rowIndex)))
            .join(",")
    );

    const csvContent = [headerRow, ...dataRows].join("\n");
    const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${fileName} ${dateLabel}.csv`;
    link.click();
    URL.revokeObjectURL(link.href);
};
